function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#263238;}\n\t.st1{fill:#40C4FF;}\n\t.st2{fill:#FFD740;}\n\t.st3{fill:#FF5252;}\n\t.st4{fill:#4DB6AC;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4FC3F7;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Bank"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.5,50.5c-0.276,0-0.5-0.224-0.5-0.5V38c0-0.276,0.224-0.5,0.5-0.5S29,37.724,29,38v12 C29,50.276,28.776,50.5,28.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M35.5,50.5c-0.276,0-0.5-0.224-0.5-0.5V38c0-0.276,0.224-0.5,0.5-0.5S36,37.724,36,38v12 C36,50.276,35.776,50.5,35.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M38,55.5c-0.276,0-0.5-0.224-0.5-0.5v-0.5c0-1.103-0.897-2-2-2h-7c-1.103,0-2,0.897-2,2V55 c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-0.5c0-1.654,1.346-3,3-3h7c1.654,0,3,1.346,3,3V55 C38.5,55.276,38.276,55.5,38,55.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M8.5,50.5C8.224,50.5,8,50.276,8,50V38c0-0.276,0.224-0.5,0.5-0.5S9,37.724,9,38v12 C9,50.276,8.776,50.5,8.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.5,50.5c-0.276,0-0.5-0.224-0.5-0.5V38c0-0.276,0.224-0.5,0.5-0.5S16,37.724,16,38v12 C16,50.276,15.776,50.5,15.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.5,36.5h-7c-1.654,0-3-1.346-3-3V33c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v0.5c0,1.103,0.897,2,2,2 h7c1.103,0,2-0.897,2-2V33c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v0.5C18.5,35.154,17.154,36.5,15.5,36.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18,55.5c-0.276,0-0.5-0.224-0.5-0.5v-0.5c0-1.103-0.897-2-2-2h-7c-1.103,0-2,0.897-2,2V55 c0,0.276-0.224,0.5-0.5,0.5S5.5,55.276,5.5,55v-0.5c0-1.654,1.346-3,3-3h7c1.654,0,3,1.346,3,3V55 C18.5,55.276,18.276,55.5,18,55.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48.5,50.5c-0.276,0-0.5-0.224-0.5-0.5V38c0-0.276,0.224-0.5,0.5-0.5S49,37.724,49,38v12 C49,50.276,48.776,50.5,48.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.5,50.5c-0.276,0-0.5-0.224-0.5-0.5V38c0-0.276,0.224-0.5,0.5-0.5S56,37.724,56,38v12 C56,50.276,55.776,50.5,55.5,50.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.5,36.5h-7c-1.654,0-3-1.346-3-3V33c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v0.5c0,1.103,0.897,2,2,2 h7c1.103,0,2-0.897,2-2V33c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v0.5C58.5,35.154,57.154,36.5,55.5,36.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58,55.5c-0.276,0-0.5-0.224-0.5-0.5v-0.5c0-1.103-0.897-2-2-2h-7c-1.103,0-2,0.897-2,2V55 c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-0.5c0-1.654,1.346-3,3-3h7c1.654,0,3,1.346,3,3V55 C58.5,55.276,58.276,55.5,58,55.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M61,61H3c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h58c0.552,0,1,0.448,1,1v2C62,60.553,61.552,61,61,61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M61,61.5H3c-0.827,0-1.5-0.673-1.5-1.5v-2c0-0.827,0.673-1.5,1.5-1.5h58c0.827,0,1.5,0.673,1.5,1.5v2 C62.5,60.827,61.827,61.5,61,61.5z M3,57.5c-0.276,0-0.5,0.225-0.5,0.5v2c0,0.275,0.224,0.5,0.5,0.5h58c0.275,0,0.5-0.225,0.5-0.5 v-2c0-0.275-0.225-0.5-0.5-0.5H3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32,36.5c-4.687,0-8.5-3.813-8.5-8.5c0-4.687,3.813-8.5,8.5-8.5c4.687,0,8.5,3.813,8.5,8.5 C40.5,32.687,36.687,36.5,32,36.5z M32,20.5c-4.136,0-7.5,3.364-7.5,7.5c0,4.135,3.364,7.5,7.5,7.5s7.5-3.364,7.5-7.5 C39.5,23.865,36.136,20.5,32,20.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M32,18c3.699,0,6.921,2.014,8.651,5H58L32,3L6,23h17.349C25.079,20.014,28.301,18,32,18z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58,23.5c-0.106,0-0.214-0.034-0.305-0.104L32,3.631L6.305,23.397c-0.219,0.169-0.533,0.128-0.701-0.092 c-0.168-0.219-0.127-0.533,0.092-0.701l26-20c0.18-0.138,0.43-0.138,0.609,0l26,20c0.219,0.168,0.26,0.482,0.092,0.701 C58.298,23.434,58.149,23.5,58,23.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M22,28c0-1.045,0.162-2.053,0.459-3H3c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h19.459 C22.162,30.053,22,29.046,22,28z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M61,25H41.541C41.838,25.948,42,26.955,42,28s-0.162,2.053-0.459,3H61c0.552,0,1-0.448,1-1v-4 C62,25.448,61.552,25,61,25z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.459,31.5H3c-0.827,0-1.5-0.673-1.5-1.5v-4c0-0.827,0.673-1.5,1.5-1.5h19.459c0.276,0,0.5,0.224,0.5,0.5 s-0.224,0.5-0.5,0.5H3c-0.276,0-0.5,0.224-0.5,0.5v4c0,0.276,0.224,0.5,0.5,0.5h19.459c0.276,0,0.5,0.224,0.5,0.5 S22.736,31.5,22.459,31.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M61,31.5H41.541c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H61c0.275,0,0.5-0.224,0.5-0.5v-4 c0-0.276-0.225-0.5-0.5-0.5H41.541c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H61c0.827,0,1.5,0.673,1.5,1.5v4 C62.5,30.828,61.827,31.5,61,31.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32,26c-0.276,0-0.5-0.224-0.5-0.5V24c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v1.5 C32.5,25.777,32.276,26,32,26z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32,32.5c-0.276,0-0.5-0.224-0.5-0.5v-1.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V32 C32.5,32.277,32.276,32.5,32,32.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32.75,31H30c-0.276,0-0.5-0.224-0.5-0.5S29.724,30,30,30h2.75c0.413,0,0.75-0.336,0.75-0.75 s-0.337-0.75-0.75-0.75h-1.5c-0.965,0-1.75-0.785-1.75-1.75S30.285,25,31.25,25h2.25c0.276,0,0.5,0.224,0.5,0.5S33.776,26,33.5,26 h-2.25c-0.413,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h1.5c0.965,0,1.75,0.785,1.75,1.75S33.715,31,32.75,31z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.5,8h-1C18.224,8,18,7.777,18,7.5S18.224,7,18.5,7h1C19.776,7,20,7.224,20,7.5S19.776,8,19.5,8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,8h-11C5.224,8,5,7.777,5,7.5S5.224,7,5.5,7h11C16.776,7,17,7.224,17,7.5S16.776,8,16.5,8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.5,11h-11C0.224,11,0,10.777,0,10.5S0.224,10,0.5,10h11c0.276,0,0.5,0.224,0.5,0.5S11.776,11,11.5,11z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M45.5,8h-1C44.224,8,44,7.777,44,7.5S44.224,7,44.5,7h1C45.776,7,46,7.224,46,7.5S45.776,8,45.5,8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58.5,8h-11C47.224,8,47,7.777,47,7.5S47.224,7,47.5,7h11C58.776,7,59,7.224,59,7.5S58.776,8,58.5,8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.5,11h-11c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h11c0.276,0,0.5,0.224,0.5,0.5S63.776,11,63.5,11z "
})));

var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.cc329744.svg";
export { ForwardRef as ReactComponent };